<div style="margin-top: 15px; margin-left:2vw;padding-left: 15px;margin-right:2vw;">
    <div class="row"
         style="margin-bottom: 5px;">
        <div class="col-8">
            <h2>
                Estructura Campo (admin)
            </h2>
            <h3 *ngIf="uuid != 0">
                {{nombre}}
                {{uuid}}
            </h3>
            <button class="btn btn-sm p-0"
                    *ngIf="uuid == 0"
                    role="button"
                    aria-pressed="true"
                    tooltip="add"
                    (click)="createRootNode()">
                <i class="material-icons">add</i>
            </button>
        </div>
        <div class="col-4">
            <ng-multiselect-dropdown [placeholder]="'Select columns'"
                                     [settings]="dropdownSettings"
                                     [data]="extraVar"
                                     [(ngModel)]="extraVarSelected"
                                     (onSelect)="onItemSelect($event)"
                                     (onSelectAll)="onSelectAll($event)">
            </ng-multiselect-dropdown>
        </div>
    </div>
    <div class="row"
         *ngIf="uuid != 0"
         style="margin-bottom: 10px;">
        <div class="col-12">
            <button (click)="goBack()"
                    class="btn btn-sm p-0"
                    role="button"
                    aria-pressed="true"
                    tooltip="arrow_back_ios">
                <i class="material-icons">arrow_back_ios</i>
            </button>
        </div>
    </div>
    <ngx-datatable class="material"
                   style="height: 75vh;"
                   [headerHeight]="50"
                   [footerHeight]="0"
                   [rowHeight]="50"
                   [columnMode]="ColumnMode.force"
                   [rows]="rows"
                   [treeFromRelation]="'parentId'"
                   [treeToRelation]="'uuid'"
                   [scrollbarV]="true"
                   [scrollbarH]="true"
                   (treeAction)="onTreeAction($event)">
        <ngx-datatable-column name="nombre"
                              [isTreeColumn]="true"
                              [width]="450"
                              [treeLevelIndent]="20">
            <ng-template ngx-datatable-tree-toggle
                         let-value="value"
                         let-row="row"
                         let-tree="cellContext">
            </ng-template>
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <i class="material-icons"
                   style="cursor: copy;"
                   ngxClipboard
                   [cbContent]="row.uuid"
                   (cbOnSuccess)="copiado($event)">
                    content_copy
                </i>
                <a *ngIf="row.labels.includes('Source')" 
                    [routerLink]="['/source', row.uuid]" 
                    target="_blank" 
                    matTooltip="Navegar al source {{row.nombre}}" 
                    style="margin-left: 5px; margin-top: -5px;"
                >
                    <i class="material-icons" style="display: inline-block; color: black">
                        speaker_phone
                    </i>
                </a>
                <a class="btn btn-sm p-0"
                   role="button"
                   aria-pressed="true"
                   tooltip="exit_to_app"
                   style="margin-left: 5px;"
                   [routerLink]="['/estructuracampoadmin', row.uuid, row.nombre]">
                    <p style="font-size: 12px;">{{row.nombre}}
                    </p>
                </a>
            </ng-template>
        </ngx-datatable-column>
        <!-- <ngx-datatable-column name="nodeLinkChilds"
                              [width]="50">
        </ngx-datatable-column> -->
        <ngx-datatable-column name="labels"
                              [width]="250">
        </ngx-datatable-column>
        <ngx-datatable-column [name]="col.name"
                              *ngFor="let col of extraVarSelected"
                              [width]="150">
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                {{returnVariable(row, col.name)}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Actions"
                              [width]="100">
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
                <button class="btn btn-sm p-0"
                        role="button"
                        aria-pressed="true"
                        tooltip="Edit"
                        (click)="open(row)">
                    <i class="material-icons">edit</i>
                </button>
                <button class="btn btn-sm p-0"
                        role="button"
                        aria-pressed="true"
                        tooltip="add"
                        (click)="create(row)">
                    <i class="material-icons">add</i>
                </button>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>